/* eslint-disable import/prefer-default-export */
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import makeRequest from '../../utils/makeRequest';

const reducerName = 'breakingNews';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

function receiveBreakingNewsData(data) {
  return {
    type: RECEIVE_DATA,
    payload: data,
  };
}

function handleBreakingNewsDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

function fetchBreakingNewsData(params) {
  //#todo find a better way to test this
  const testURL =
    'https://timesofindia.indiatimes.com/feed_breakingnews/feedtype-json.cms';
  const liveURL =
    'https://toibnews.timesofindia.indiatimes.com/Election/election2017_breakingnews.htm';
  const url = params.isTest ? testURL : liveURL;
  return makeRequest.get(url);
}

export function loadBreakingNewsData(params) {
  return dispatch =>
    fetchBreakingNewsData(params)
      .then(data => dispatch(receiveBreakingNewsData(data.data)))
      .catch(error => dispatch(handleBreakingNewsDataError(error)));
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_DATA:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
